import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import classes from "./Sidebar.module.scss";
import Swal from "sweetalert2"; // Import SweetAlert2
import "../../css/Sidebar.css";
import logo from "../../assets/Appan Courier Logo.png";
import SidebarCloseIcon from "../../assets/Icons/SidebarCloseIcon.svg";
import { LuLogOut } from "react-icons/lu";
import CustomAlert from "../../helpers/CustomAlert";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import routes from "../../components/routes/Routes";
import { useDispatch } from "react-redux";
import { fadeIn } from "react-animations";
import styled, { keyframes } from "styled-components";
import { logout } from "../store/authSlice";
import { Tooltip } from "@mui/material";

const slideIn = keyframes`${fadeIn}`;
const AnimatedCard = styled.div`
  animation: 0.7s ${slideIn};
`;

const Sidebar = ({ props, handleToggleSidebar }) => {
  const loggedInUserName = sessionStorage.getItem("username");

  const navigate = useNavigate();
  const { PROTECTED_ROUTES } = routes();
  const [selectedChildRoute, setSelectedChildRoute] = useState(null);

  const location = useLocation();
  const [activeRoute, setActiveRoute] = useState("dashboard");
  const [sideBarHovered, setSideBarHovered] = useState(true);
  const [expandedRoute, setExpandedRoute] = useState(null);
  const [opens, setOpens] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const storedExpandedRoute = sessionStorage.getItem("expandedRoute");
    if (storedExpandedRoute) {
      setExpandedRoute(storedExpandedRoute);
    }
  }, []);

  useEffect(() => {
    if (location.pathname === "/") setActiveRoute("dashboard");
    else {
      PROTECTED_ROUTES.forEach((route) =>
        location.pathname.includes(route.id) ? setActiveRoute(route.id) : null
      );
    }
  }, [location]);

  useEffect(() => {
    sessionStorage.getItem("menu");
  }, []);

  const handleRouteChange = (route) => {
    setActiveRoute(route.id);
    navigate(route.url);
    setExpandedRoute(null);
    sessionStorage.setItem("expandedRoute", null);
    setOpens(false);
  };

  const handleChildRouteChange = (parent, child) => {
    setActiveRoute(parent.id);
    navigate(`${parent.url}${child.url}`);
    setExpandedRoute(parent.name);
    sessionStorage.setItem("expandedRoute", parent.name);
    setOpens(false);
  };

  const openSidebar = () => {
    document.getElementById("mySidebar").style.width = "15.344vw";
    // document.getElementById('MenuItems').style.width = 'max-content';
    setSideBarHovered(true);
  };

  const closeSidebar = () => {
    document.getElementById("mySidebar").style.width = "3.762vw";
    // document.getElementById('MenuItems').style.width = '0vw';
    setSideBarHovered(false);
  };

  const hover = () => {
    setSideBarHovered(false);
  };

  const processedRoutes = PROTECTED_ROUTES.map((route) => {
    if (!route.childRoutes) {
      if (route.arr == true) return route;
      else return false;
    } else {
      let childRoutes = route.grandChild?.filter((child) => child.arr == "1");
      if (childRoutes.length) return { ...route, childRoutes: childRoutes };
      else return false;
    }
  }).filter(Boolean);

  const handleLogout = () => {
    Swal.fire({
      title: "Do you want to logout?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#00b6ce",
      cancelButtonColor: "#e74c3c",
      confirmButtonText: "Yes, log me out!",
      cancelButtonText: "No",
      customClass: {
        confirmButton: "swal-confirm-button",
        cancelButton: "swal-cancel-button",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const requestBody = {
          username: loggedInUserName,
        };

        axiosPostApi(apiList.LOGOUT, requestBody)
          .then((response) => {
            if (response.status === 200) {
              sessionStorage.removeItem("token");
              sessionStorage.removeItem("name");
              sessionStorage.removeItem("username");
              sessionStorage.removeItem("loginTime");
              dispatch(logout());
              navigate("/auth/login");
            } else {
              CustomAlert({
                title: "Failed to Logout",
                text:
                  response.data.message ||
                  "No data available for the specified criteria.",
                icon: "error",
                confirmButtonText: "Retry",
              }).then((result) => {
                if (result.isConfirmed) {
                  sessionStorage.clear();
                  window.location.href = "/";
                }
              });
            }
          })
          .catch((error) => {
            CustomAlert({
              title: "Error",
              text: "An error occurred while logging out. Please try again later.",
              icon: "error",
              confirmButtonText: "Retry",
            }).then((result) => {
              if (result.isConfirmed) {
                sessionStorage.clear();
                window.location.href = "/";
              }
            });
          });
      }
    });
  };

  const tooltipMap = {
    "Purchase Credits": "Company purchase from vendor",
    "Customer SMS Logs": "Customer send SMS",
    "Customer RCS Logs": "Customer send RCS",
    "System SMS Logs": "System Send SMS",
    "Top-Up SMS/RCS": "Customer Top-Up SMS/RCS",
  };

  return (
    <div className="side-header">
      <div className="sideheader-upper-section">
        <img
          src={SidebarCloseIcon}
          className="sideheader-close-btn"
          alt="Sidebar Close Icon"
          onClick={() => {
            handleToggleSidebar();
          }}
        />
        <img src={logo} alt="Appan Tech Logo" className="appan-logo" />
      </div>

      <ul className="list-unstyled">
        {processedRoutes.map(({ ...route }) =>
          route.grandChild?.length ? (
            <div key={route.id}>
              <li
                className={
                  activeRoute === route.id ? `${"link"} ${"active"}` : "link"
                }
                onClick={() =>
                  setExpandedRoute((prev) =>
                    prev === route.name ? null : route.name
                  )
                }
              >
                <span className="icon">
                  <img src={route.Icon} alt="icon" />
                </span>
                {sideBarHovered && (
                  <AnimatedCard className={classes.parentList}>
                    <div>{route.name}</div>
                  </AnimatedCard>
                )}
              </li>
              {sideBarHovered && expandedRoute === route.name && (
                <AnimatedCard className={classes.childRoutesContainer}>
                  {route.grandChild?.map(
                    (child) =>
                      child.arr == "1" && (
                        <li
                          onClick={() => handleChildRouteChange(route, child)}
                        >
                          {sideBarHovered && <div>- {child.name}</div>}
                        </li>
                      )
                  )}
                </AnimatedCard>
              )}
            </div>
          ) : (
            <Tooltip
              title={tooltipMap[route?.name] || ""}
              arrow
              placement="right"
            >
              <li
                key={route.id}
                onClick={() => handleRouteChange(route)}
                className={
                  activeRoute === route.id ? `${"link"} ${"active"}` : "link"
                }
              >
                <span className="icon">
                  <img src={route.Icon} alt="icon" />
                </span>
                {sideBarHovered && <AnimatedCard>{route.name}</AnimatedCard>}
              </li>
            </Tooltip>
          )
        )}
        <li>
          <button onClick={handleLogout} className="link logout-button">
            <span className="icon">
              <LuLogOut size={20} />
            </span>
            Logout
          </button>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
